import Crud from '../components/NetworkDiagram/Crud'
import Add from '../components/NetworkDiagram/Add'

let routes = {
    path: '/network-diagrams',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/network-diagrams/add',
            name: 'Novo Diagrama de Rede',
            component: Add
        },
        {
            path: '/network-diagrams/edit/:id?',
            name: 'Editar Diagrama de Rede',
            component: Add
        },
        {
            path: '/network-diagrams',
            name: 'Diagramas de Rede',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/network-diagram.js